import type React from 'react';

import { Camera, House } from '@shared/assets';

import * as st from './Icon.module.scss';

type Props = {
	type: string;
};

const modes: { [x: string]: () => JSX.Element } = {
	ON: Camera,
	OF: House,
};

const Icon: React.FC<Props> = ({ type }) => {
	return <div className={st.icon}>{modes[type]()}</div>;
};

export default Icon;
